import { type DashboardWidget, type DashboardWidgetGrouping } from '@terros/common'
import { groupingToOption } from '../report/grouping'

export type GroupedDashboardWidget = Extract<DashboardWidget, { type: 'leaderboard' | 'table' }>

const MANAGER_GROUPING_VALUE = 'manager'
const MANAGER_LEVEL_GROUPING_PREFIX = 'manager|'

export function isGroupedWidget(widget: DashboardWidget): widget is GroupedDashboardWidget {
  return widget.type === 'leaderboard' || widget.type === 'table'
}

export const DEFAULT_WIDGET_GROUPING: DashboardWidgetGrouping = { type: 'user' }

export function getWidgetGrouping(widget: GroupedDashboardWidget): DashboardWidgetGrouping {
  return widget.grouping ?? DEFAULT_WIDGET_GROUPING
}

export function withWidgetGrouping(widget: GroupedDashboardWidget, grouping: DashboardWidgetGrouping): DashboardWidget {
  switch (widget.type) {
    case 'leaderboard':
      return { ...widget, grouping }
    case 'table':
      return { ...widget, grouping }
  }
}

export function toWidgetGroupingValue(grouping: DashboardWidgetGrouping): string {
  if (grouping.type === 'manager') {
    return grouping.level ? `${MANAGER_LEVEL_GROUPING_PREFIX}${grouping.level}` : MANAGER_GROUPING_VALUE
  }
  return String(groupingToOption(grouping))
}

export function toWidgetGrouping(value: string): DashboardWidgetGrouping | undefined {
  if (value === 'user') return DEFAULT_WIDGET_GROUPING
  if (value === MANAGER_GROUPING_VALUE) return { type: 'manager' }
  if (value.startsWith(MANAGER_LEVEL_GROUPING_PREFIX)) return toManagerLevelGrouping(value)
  const level = Number(value)
  if (!Number.isInteger(level) || level < 1) return undefined
  return { type: 'team', level }
}

function toManagerLevelGrouping(value: string): DashboardWidgetGrouping | undefined {
  const level = Number(value.replace(MANAGER_LEVEL_GROUPING_PREFIX, ''))
  if (!Number.isInteger(level) || level < 1) return undefined
  return { type: 'manager', level }
}
